import React from 'react';
import { Loader2, SearchX } from 'lucide-react';
import ResultCard from './ResultCard';
import { SEARCH_TYPES } from './searchConfig';

function ResultsPanel({ query, loading, error, groups, results, activeType, counts }) {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-slate-200 p-12 text-center">
        <Loader2 className="mx-auto mb-3 h-10 w-10 animate-spin text-brand-primary" />
        <p className="text-sm text-slate-500 font-montserrat">Buscando en la operacion...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 rounded-lg border border-red-200 p-6 text-sm text-red-700">
        {error}
      </div>
    );
  }

  if (!query.trim()) {
    return (
      <div className="bg-white rounded-lg border border-slate-200 p-8">
        <div className="max-w-3xl">
          <h2 className="text-lg font-bold text-slate-900 font-montserrat">Busca cualquier pieza de la entrega</h2>
          <p className="mt-2 text-sm text-slate-500">
            Usa ID, telefono, DNI, tracking, nombre, direccion, provincia, driver, tienda o estado.
          </p>
          <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {[
              'Entrega Lima por telefono o direccion',
              'Provincia por DNI, agencia o codigo',
              'Express por recojo, destino o conductor',
              'Paquetes por tracking o SKU',
            ].map((hint) => (
              <div key={hint} className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs font-semibold text-slate-600">
                {hint}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!results.length) {
    return (
      <div className="bg-white rounded-lg border border-slate-200 p-12 text-center">
        <SearchX className="mx-auto mb-3 h-12 w-12 text-slate-300" />
        <h2 className="text-lg font-bold text-slate-900">Sin resultados</h2>
        <p className="mt-1 text-sm text-slate-500">
          No encontramos datos para "{query}". Prueba con telefono sin espacios, ID exacto o tracking.
        </p>
      </div>
    );
  }

  if (activeType !== 'all') {
    return (
      <div className="grid gap-3 lg:grid-cols-2">
        {results.map((result) => (
          <ResultCard key={`${result.type}-${result.id}`} result={result} />
        ))}
      </div>
    );
  }

  const orderedGroups = SEARCH_TYPES.filter((type) => type.id !== 'all');

  return (
    <div className="space-y-6">
      <section>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-sm font-extrabold uppercase tracking-wide text-slate-500">Mejores coincidencias</h2>
          <span className="text-xs text-slate-400">{results.length} resultados priorizados</span>
        </div>
        <div className="grid gap-3 lg:grid-cols-2">
          {results.slice(0, 6).map((result) => (
            <ResultCard key={`best-${result.type}-${result.id}`} result={result} />
          ))}
        </div>
      </section>

      {orderedGroups.map((type) => {
        const groupResults = groups?.[type.id] || [];
        if (!groupResults.length) return null;
        const Icon = type.icon;
        return (
          <section key={type.id}>
            <div className="mb-3 flex items-center gap-2">
              <Icon className="h-4 w-4 text-slate-500" />
              <h2 className="text-sm font-extrabold uppercase tracking-wide text-slate-600">
                {type.label}
              </h2>
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-500">
                {counts?.[type.id] ?? groupResults.length}
              </span>
            </div>
            <div className="grid gap-3 lg:grid-cols-2">
              {groupResults.map((result) => (
                <ResultCard key={`${type.id}-${result.id}`} result={result} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}

export default ResultsPanel;
